module.exports = __webpack_public_path__ + "static/media/slzhitui-fuwu-4.380cf00c.png";